function isValidKenyanId(nationalId) {
    // Check if nationalId is undefined, null, or not a string
    if (typeof nationalId !== 'string' || !nationalId.trim()) {
        return false;
    }

    // Remove all non-digit characters
    const cleanId = nationalId.replace(/\D/g, '');

    // Check length is exactly 8 digits
    if (cleanId.length !== 8) {
        return false;
    }

    // Check it consists only of digits
    if (!/^\d+$/.test(cleanId)) {
        return false;
    }

    // Check for invalid patterns
    const invalidPatterns = ['00000000', '12345678', '87654321'];
    if (invalidPatterns.includes(cleanId)) {
        return false;
    }

    // First digit should not be 0
    if (cleanId[0] === '0') {
        return false;
    }

    return true;
}

export default isValidKenyanId;
